<template>
  <div>
    <div class="benefit_list_wrap">
      <div
        :class="{
          benefit_small_list: size === 'small',
          benefit_list_box: size !== 'small',
          style_1: isNewUserStatus,
          style_2: !isNewUserStatus,
        }"
      >
        <template v-if="size !== 'small'">
          <benefitItem
            v-for="(item, index) in benefitList"
            :key="index"
            :item="item"
            @goDetailed="data => goDetailed(data, index)"
            @goSettingBir="goSettingBir"
            @getBirthdayCoupons="getBirthdayCoupons"
            @goCoupons="goCoupons"
            @jumpBenefit="jumpBenefit"
          />
        </template>
        <template v-else>
          <benefitSmallItem
            v-for="(item, index) in benefitList"
            :key="index"
            :item="item"
            @goDetailed="data => goDetailed(data, index)"
            @goSettingBir="goSettingBir"
            @getBirthdayCoupons="getBirthdayCoupons"
            @goCoupons="goCoupons"
            @jumpBenefit="jumpBenefit"
          />
        </template>
      </div>

      <CouponSuccessDialog v-model="isShowCouponSuccessDialog" @goCoupons="goCoupons" />

      <!-- swiperBanner -->
      <swiperBanner
        v-if="isShowPop"
        :sData="benefitList"
        :initialSlide="initialSlide"
        @close="closeSwiper"
        @goSettingBir="goSettingBir"
        @getBirthdayCoupons="getBirthdayCoupons"
        @goCoupons="goCoupons"
        @jumpBenefit="jumpBenefit"
      />
    </div>
    <LoadingMask v-if="requestLoading" :type="loadingType" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoadingMask from '@/components/loading/loading-mask.vue'
import swiperBanner from '@/page/member/components-v2/swiper-banner.vue'
import benefitItem from './benefit-item.vue'
import benefitSmallItem from './benefit-small-item.vue'
import {
  BENEFIT_OPEN_DIALOG_TYPE,
  COUPON_URL_DIDI,
  BENEFIT_JUMP_TYPE,
  mobilityCouponItem,
  entregaCouponItem,
  GLOBAL_EMBED_CUSTOMER,
} from '@/page/member/common/enumsUtil.js'
import { getBirthdayBenefit, updateUserInfo } from '@/api/member/index.js'
import { membershipLandingBirthdayCk } from '@/page/member/trackEvent.js'
import CouponSuccessDialog from '../coupon-success-dialog.vue'
import { switchToRider } from '@/common/js/bridge.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberBenefitList',
  components: {
    swiperBanner,
    benefitItem,
    benefitSmallItem,
    CouponSuccessDialog,
    LoadingMask,
  },
  mixins: [mixin],
  inject: ['initCodeData'],
  props: {
    // 权益信息
    benefitInfo: {
      type: Object,
      default: () => {},
    },
    // 权益列表
    benefitList: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestLoading: false,
      /** @desc swiper */
      isShowPop: false, // 弹窗
      initialSlide: 0, // 最初始的幻灯片索引
      /** @desc other */
      isShowCouponSuccessDialog: false,
      itemType: '',
    }
  },
  computed: {
    ...mapState(['membership']),
    isGlobalEmbedCustomer() {
      // 在ImmersionHeader组件内进行过一次获取公参的操作，所以这里直接使用了
      return this.$store?.state?.globalParams?.data?.clientType === GLOBAL_EMBED_CUSTOMER
    },
  },
  methods: {
    isDeliveryBenefitJump(itemType) {
      // 闪送权益的跳转行为和出行一致，所以将该逻辑收敛到这里
      return itemType === mobilityCouponItem || itemType === entregaCouponItem
    },
    closeSwiper() {
      this.isShowPop = false
    },
    // 跳转到详情弹窗
    goDetailed(data, index) {
      this.isShowPop = true
      this.initialSlide = index
      this.itemType = data?.itemType
      this.membershipLandingCkFn(BENEFIT_OPEN_DIALOG_TYPE[this.itemType])
    },
    // 跳转到设置生日弹窗
    goSettingBir() {
      this.closeSwiper()

      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: this.$t('FoodC_birthday_lxme_nZrh'),
          subtitle: this.$t('FoodC_birthday_JshR_FWPW'),
          confirmTxt: this.$t('FoodC_birthday_bthp_qePu'),
          min: new Date(1900, 1, 1),
          max: new Date(),
          value: new Date(),
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle,
        })
      }
      this.datePicker.show()
    },
    // 添加前导零
    addLeadingZero(number) {
      return number < 10 ? '0' + number : number
    },
    async selectHandle(date) {
      this.requestLoading = true
      const res = await updateUserInfo({
        birthday: this.withoutTime(date),
      })
      const birString = this.withoutTime(date, 'string')
      this.membershipLandingBirthdayCkFn(birString)
      this.requestLoading = false

      if (res.errno === 0) {
        await this.initCodeData()
      } else {
        this.createErrorToast(res?.errmsg || '')
      }
    },
    cancelHandle() {},
    // 转换时间格式
    withoutTime(dateString, type = '') {
      // 创建日期对象
      const date = new Date(dateString)
      // 获取年、月、日
      const year = date.getFullYear()
      const month = date.getMonth() + 1 // 月份从0开始，需要加1
      const day = date.getDate()
      let formattedDate = ''

      if (type === 'string') {
        // 格式化日期
        formattedDate =
          year.toString() +
          this.addLeadingZero(month).toString() +
          this.addLeadingZero(day).toString()
        return formattedDate
      } else {
        // 格式化日期
        formattedDate = year + '-' + this.addLeadingZero(month) + '-' + this.addLeadingZero(day)
        return formattedDate
      }
    },
    // 埋点
    membershipLandingBirthdayCkFn(birString) {
      membershipLandingBirthdayCk({ birthday: birString })
    },
    // 领取生日券
    async getBirthdayCoupons() {
      this.closeSwiper()

      this.requestLoading = true
      const res = await getBirthdayBenefit()
      this.requestLoading = false

      if (res.errno === 0) {
        this.isShowCouponSuccessDialog = true
        await this.initCodeData()
      } else {
        const toast = this.$createToast({
          txt: this.$t('FoodC_birthday_UhuO_lUDL'),
          time: 2000,
          type: 'warn',
          mask: false,
        })
        toast.show()
      }
    },
    // 跳转到优惠券中心
    goCoupons() {
      window.SodaBridge('openPage', { target: 'blank', url: COUPON_URL_DIDI })
    },
    jumpBenefit(data) {
      this.closeSwiper()
      this.requestLoading = true

      const { clickUrl, itemType } = data
      this.membershipLandingCkFn(BENEFIT_JUMP_TYPE[itemType])

      setTimeout(() => {
        this.requestLoading = false
        // 如果是嵌入端，调用bridge方法进行跳转
        if (this.isGlobalEmbedCustomer && this.isDeliveryBenefitJump(itemType)) {
          switchToRider({ url: clickUrl })
          return
        }
        window.SodaBridge('openPage', { target: 'blank', url: clickUrl })
      }, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
.benefit_list_box {
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &.style_2 {
    > div {
      background-color: #fff;
    }
  }
}
.benefit_small_list {
  padding-left: 20px;
  display: flex;
  flex-wrap: wrap;
  &.style_2 {
    > div {
      background-color: #fff;
    }
  }
  > div {
    margin-right: 14px;
  }
}
</style>
